export default "__VITE_ASSET__C96fxF18__"